import React, { useState, useEffect, useContext } from "react";
import Dropdown from "core/ui/Dropdown";
import SessionContext from "SessionContext";
import { ValidateCost, HandleCostPaste, HandleCostKey } from "./royalty-partials/royalty-helpers";
import { Input, Label, Form, FormGroup, Col, InputGroup, InputGroupText, Button } from "reactstrap"


function ChannelDetails(props) {
  const {
    select,
    preSetChannel = null,
    preSetPrice = null,
    preSetDate = null,
    channelHasChanged = false
  } = props;
  const session = useContext(SessionContext);

  const [channelOptionList, setChannelOptionList] = useState(null);
  const [channelName, setChannelName] = useState("");
  const [channelId, setChannelId] = useState(preSetChannel || 0);
  const [channelDate, setChannelDate] = useState(0);
  const [oldDate, setOldDate] = useState(null);
  const [channelCost, setChannelCost] = useState(preSetPrice || 0);
  const [modified, setModified] = useState(false);

  useEffect(() => {
    loadChannelOptionList();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(preSetDate && !oldDate) {
      setOldDate(displayDate(preSetDate));
    } else if(!preSetDate) {
      setOldDate(null);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preSetDate])

  function loadChannelOptionList() {
    session
      .query("admin/get_channel_options")
      .then((response) => {
        setChannelOptionList(response);
      })
      .catch((error) => {
        console.log(JSON.stringify(error));
      });
  }

  useEffect(() => {
    if (preSetPrice !== null && preSetDate !== null) {
      setTimeout(() => {
        setChannelDate(preSetDate.replace(/[-//]/g, ""));
        setChannelCost(preSetPrice);
        setChannelId(preSetChannel);
      }, 500);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preSetPrice, preSetDate]);

  const handleUpdate = () => {
    let prettyChannelFormat = {
      channel_option_id: channelId,
      effective_date: channelDate,
      cost_per_record: Number(channelCost),
    };
    setOldDate(displaySelectedDay(channelDate));
    select(prettyChannelFormat);
    channelHasChanged(true);
    setModified(true);
  };

  const handleChannel = (value) => {
    setChannelId(value.id);
    setChannelName(value.name);
  };

  const handleDate = (value) => {
    if(!value || value.length < 7) {
      setChannelDate(0);
      return;
    }
    let formattedDate = value.replace(/[-//]/g, "");
    setChannelDate(formattedDate);
  };

  const handleCost = (event) => {
    const value = event.target.value;
    const validated = ValidateCost(value);
    if (validated) {
      setChannelCost(value);
    }
  };

  const checkIfChanged = () => {
    // can't update without price or date
    if(channelCost <= 0 || channelDate <= 0) {
      setModified(true);
      return;
    }
    // prep values for comparison
    let pre_setDate = preSetDate ? preSetDate.replace(/[-//]/g, "") : preSetDate;
    let new_date = channelDate ? channelDate.replace(/[-//]/g, "") : channelDate;
    let pre_setPrice = preSetPrice ? preSetPrice.toString() : preSetPrice;
    let new_price = channelCost ? channelCost.toString() : channelCost;
    if (
      new_price !== pre_setPrice ||
      new_date !== pre_setDate ||
      channelId !== preSetChannel.id
    ) {
      setModified(false);
    } else {
      setModified(true);
    }
  };

  const displayDate = (value) => {
    if(value !== null) {
      let year = value.slice(0, 4);
      let month = value.slice(5, 7);
      let day = value.slice(8, 10);
      return `${month}/${day}/${year}`; 
    }
  };

  const displaySelectedDay = (value) => {
    if(!value) {return "";}
    /* month / day / year */
    return `${value.slice(4, 6)}/${value.slice(6, 8)}/${value.slice(0, 4)}`;
  }

  useEffect(() => {
    checkIfChanged();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelCost, channelDate, channelId])


  return (
    <div className="channel-details">
      <div>
        <div className="channel-remove">
          <span>
            Channel: <strong>{channelName}</strong>
          </span>
        </div>
        <Dropdown
          label="Select Channel"
          options={channelOptionList}
          select={handleChannel}
          remove={false}
          preSelect={channelId}
        />
      </div>
      <div className="right-aligned">
        <Form>
          <FormGroup row>
            <Label
              for="royalty-cost"
              sm={6}>
              Price:
            </Label>
            <Col sm={6}>
            <InputGroup>
              <InputGroupText>
                <i className="bi bi-currency-dollar"></i>
              </InputGroupText>
                <Input
                  id="royalty-cost"
                  type="text"
                  value={channelCost}
                  onChange={(e) => handleCost(e)}
                  onKeyDown={(e) => HandleCostKey(e)}
                  onPaste={(e) => HandleCostPaste(e)}
                />
            </InputGroup>
          </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={6}>Current Effective Date:</Label>
            <Col sm={6}>
              <div className="left-aligned"><span className="royalty-old-date">
                {oldDate || <span className="text-danger no-selection">None Selected</span>}
              </span></div>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label
              sm={6}
            >
              Select a New Date:{" "}
            </Label>
            <Col sm={6}>
              <InputGroup>
                <InputGroupText><i className="bi bi-calendar-check"></i></InputGroupText>
              <Input
                type="date"
                onChange={(e) => handleDate(e.target.value)}
                />
              </InputGroup>
            </Col>

          </FormGroup>
        <FormGroup>
          <br />
          <Button className="promote" type="button" onClick={handleUpdate} disabled={modified}>
            Update
          </Button>
        </FormGroup>
        </Form>
      </div>
    </div>
  );
}

export default ChannelDetails;
